import { Commands } from "@highmarch/domain";
import type { Command } from "@highmarch/domain";
import type { DialogOptions } from "./dialog";

/**
 * Demolishing a tower (DESIGN §4.6, §6.2): there is no in-level currency, so it refunds nothing and only frees the
 * cell. It used to be a one-tap "Sell tower" that read like a refund; now it says what it does and asks first.
 */
export function demolishDialog(towerName: string, tier: number): DialogOptions {
  return { title: "DEMOLISH?", body: `Tear down your tier ${tier} ${towerName}? Nothing comes back.`, confirm: "DEMOLISH", cancel: "CANCEL", danger: true };
}

/** Asks, and demolishes only on DEMOLISH. Resolves whether it did. */
export async function confirmDemolish(ask: (o: DialogOptions) => Promise<boolean>, execute: (c: Command) => void, towerId: number, towerName: string, tier: number): Promise<boolean> {
  if (!(await ask(demolishDialog(towerName, tier)))) return false;
  execute(Commands.sellTower(towerId));
  return true;
}
